module.exports = {
	devices: [
		{text: "Ordinateur", value: "desktop"},
		{text: "Mobile", value: "mobile"}
	]
};